<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Nome Completo</h1>
      <p>Agora, por favor, forneça seu <strong>Nome completo</strong>, sua <strong>Data de Nascimento</strong> e o <strong>Nome Completo da sua Mãe</strong></p>      
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
         <form @submit="onSubmit">
            <div class="form-group text-left">
              <label for="nomeCompleto">Nome completo</label>
              <input class="form-control form-control-lg" v-model="fullName" @keyup="AlterarNome" type="text" required />
            </div>
            <div class="form-group text-left">
              <label>Nome Completo da Mãe</label>
              <input class="form-control form-control-lg" v-model="currentUser.Pessoal.NomeCompletoMae" @keyup="AlterarNome" type="text" required />
            </div>
            <div class="form-group text-left">
              <label for="DataNascimento">Data de Nascimento</label>
              <input class="form-control form-control-lg" v-model="currentUser.Pessoal.DataNascimento" v-mask="'date'" type="text" placeholder="__/__/____" title="dd/mm/yyyy" required pattern="\d{2}/\d{2}/\d{4}"/>
            </div>
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>             
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ArrayHelper from '@/utils/array-helper'

export default {
  data() {
    const pessoal = this.currentUser.Pessoal
    return {
      fullName: pessoal ? pessoal.NomeCompleto : null
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    validate() {
      if(this.fullName.indexOf(" ") > 0 && this.currentUser.Pessoal.NomeCompletoMae.indexOf(" ") > 0) {
        return {isValid: true, errors: ['É obrigatório o envio do nome completo']}
      } else {
        return {isValid: false, errors: ['É obrigatório o envio do nome completo']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      
      const validation = this.validate()

      if(validation.isValid) {
        this.currentUser.Pessoal.NomeCompleto = this.fullName
        this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})

      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)
        })
      }

      
    }, AlterarNome(event) {
      
            var texto = event.target.value;

            var textoFinal = "";
            texto = texto.toLowerCase();

            if (texto.length > 0) {
                textoFinal = texto.substr(0, 1).toUpperCase()

                for (var i = 1; i < texto.length; i++) {
                    if (texto.substr(i - 1, 1) == " ") {
                        textoFinal += texto.substr(i, 1).toUpperCase();
                    } else {
                        textoFinal += texto.substr(i, 1);
                    }
                }
            }

          event.target.value =  textoFinal;
        }
  },
  created() {
    if(!this.currentUser.Pessoal) this.currentUser.Pessoal = {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/FullNameStep.vue